
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';
import Partnership from '../../../../components/docs/plaidoms/Partnership';
export const metadata = {
  toc: true,
  layout: 'guide',
  maxTocLevel: 4,
  skipLLM: true,
  description: 'Integrate Plaid and Marqeta\'s APIs to seamlessly authenticate your customer\'s bank account prior to an ACH transfer'
};
export const partnerProps = {
  partner: 'Marqeta',
  clientLibrary: 'marqeta',
  subtitle: metadata.description,
  registrationUrl: 'https://www.marqeta.com/users/sign_up',
  apiUrl: 'https://www.marqeta.com/docs/core-api/account-holder-funding-sources',
  extraSetupInstructions: 'Once your account is active, you then need to work with your Marqeta representative to request enablement of the Plaid integration for your program\'s private sandbox.',
  isPaymentProcessor: true
};

const layoutProps = {
  metadata,
partnerProps
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Partnership.Header {...partnerProps} />
    <h4 {...{
      "id": "overview"
    }}>{`Overview`}</h4>
    <p>{`Plaid and Marqeta have partnered to integrate Plaid's data connectivity platform with Marqeta's modern card-issuing platform.`}</p>
    <p>{`This integration will enable you to seamlessly create a validated funding source for a Marqeta-powered card:`}</p>
    <ol>
  <li>Instantly authenticate users' bank accounts with Plaid Link (i.e. optimize user conversion, shorten wait times to verify the funding source, avoid micro-deposits).</li>
  <li>Securely share tokenized banking data to integrate with Marqeta's ACH Origination solution.</li>
    </ol>
    <p>{`To help maintain the highest levels of data security, this partner integration will tokenize all sensitive bank account information to limit exposing personally identifiable information (PII).`}</p>
    <p>{`Value Props`}</p>
    <ul>
      <li parentName="ul">{`Marqeta and Plaid have partnered on an integration to enable clients to instantly authenticate consumer and business accounts with Plaid, and securely share authenticated payment information with Marqeta for card account funding.`}</li>
    </ul>
    <h4 {...{
      "id": "getting-started"
    }}>{`Getting Started`}</h4>
    <Partnership.GettingStarted {...partnerProps} />
    <h4 {...{
      "id": "instructions"
    }}>{`Instructions`}</h4>
    <Partnership.AuthInstructions {...partnerProps} />
    <Partnership.Server {...partnerProps} />
    <h4 {...{
      "id": "launching-to-production"
    }}>{`Launching to Production`}</h4>
    <Partnership.Conclusion {...partnerProps} />
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "overview",
        level: 4,
        title: "Overview",
      },
{
        id: "getting-started",
        level: 4,
        title: "Getting Started",
      },
{
        id: "instructions",
        level: 4,
        title: "Instructions",
      },
{
        id: "launching-to-production",
        level: 4,
        title: "Launching to Production",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
